import React from "react";
import i18n from "micro-i18n";
import PropTypes from "prop-types";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/compliance/Compliance.scss';

const Compliance = ({ complianceUrl }) => {
  if (!complianceUrl) {
    return null;
  }

  return (
    <div className="csw-compliance">
      <span>{i18n.t("POWERED_BY_CIVICSCIENCE")} | </span>
      <a href={complianceUrl} className="csw-compliance-link outline" target="_blank" rel="noopener noreferrer">
        {i18n.t("PRIVACY_POLICY")}
      </a>
    </div>
  );
};

Compliance.propTypes /* remove-proptypes */ = {
  complianceUrl: PropTypes.string,
};

export default Compliance;
